import { render, staticRenderFns } from "./NutrientTargets.vue?vue&type=template&id=7480f942&scoped=true&"
import script from "./NutrientTargets.vue?vue&type=script&lang=js&"
export * from "./NutrientTargets.vue?vue&type=script&lang=js&"
import style0 from "./NutrientTargets.vue?vue&type=style&index=0&id=7480f942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7480f942",
  null
  
)

export default component.exports